@if (formControlItem().invalid && (alwaysShowErrors() || formControlItem().dirty || formControlItem().touched)) {
    <stby-errors>
        @if (
            formControlItem().errors.required ||
            formControlItem().errors.requiredWithout ||
            formControlItem().errors.requiredWith ||
            formControlItem().errors.requireLength
        ) {
            <stby-error>
                {{ 'error.validation.required' | translate: { field: (requiredLabel() | translate) } }}
            </stby-error>
        }
        @if (formControlItem().errors.minlength) {
            <stby-error>
                {{
                    'error.validation.min_length'
                        | translate: { length: formControlItem().errors.minlength.requiredLength }
                }}
            </stby-error>
        }
        @if (formControlItem().errors.maxlength) {
            <stby-error>
                {{
                    'error.validation.max_length'
                        | translate: { length: formControlItem().errors.maxlength.requiredLength }
                }}
            </stby-error>
        }
        @if (formControlItem().errors.email) {
            <stby-error>
                {{ 'error.validation.email' | translate }}
            </stby-error>
        }
        @if (formControlItem().errors.min) {
            <stby-error>
                {{ 'error.validation.min' | translate: { value: formControlItem().errors.min.min } }}
            </stby-error>
        }
        @if (formControlItem().errors.max) {
            <stby-error>
                {{ 'error.validation.max' | translate: { value: formControlItem().errors.max.max } }}
            </stby-error>
        }
        @if (formControlItem().errors.pattern) {
            <stby-error>
                {{ 'error.validation.pattern' | translate }}
            </stby-error>
        }
        @if (formControlItem().errors.iban) {
            <stby-error>
                {{ 'error.validation.iban' | translate }}
            </stby-error>
        }
        @if (formControlItem().errors.requiredContent) {
            <stby-error>
                {{
                    'error.validation.required_content'
                        | translate: { content: (formControlItem().errors.requiredContent | translate) }
                }}
            </stby-error>
        }
        @if (formControlItem().errors.atLeastOneRequired) {
            <stby-error>
                {{ 'error.validation.at_least_one_required' | translate }}
            </stby-error>
        }
        @if (formControlItem().errors.dateFormat) {
            <stby-error>
                {{ 'error.validation.date_format' | translate }}
            </stby-error>
        }
        @if (formControlItem().errors.openDaysRequired) {
            <stby-error>
                {{ 'error.validation.open_days_required' | translate }}
            </stby-error>
        }
        @if (formControlItem().errors.invalidDate) {
            <stby-error>
                {{ 'error.validation.invalid_date' | translate }}
            </stby-error>
        }
    </stby-errors>
}
